<script lang="ts">
    import { getContext } from "svelte";
    import { navigate } from "svelte-navigator";
    import SearchBarModal from "./modals/SearchBarModal.svelte";
    import { api } from "./stores";

    const { open, close } = getContext("simple-modal");

    function search(searchValue: string) {
        navigate(
            "/catalog/" +
                $api.getOperationCode() +
                "/" +
                $api.getShopId() +
                "/products?search=" +
                searchValue
        );
    }

    function openModal() {
        close();
        open(
            SearchBarModal,

            {
                onSearch: (searchValue: string) => {
                    console.log("on va seatrhc:", searchValue);
                    search(searchValue);
                    close();
                },
                onClose: () => {
                    close(SearchBarModal);
                },
            },
            {
                styleWindow: {
                    background: "unset",
                },
                styleCloseButton: {
                    display: "none",
                },
                styleContent: {
                    padding: "0",
                    marginTop: "7rem",
                },
                styleWindowWrap: {
                    margin: "2px",
                },
                styleBg: {
                    justifyContent: "start",
                },
            }
        );
    }
</script>

<button class="button btn-icon" on:click={openModal}>
    <i class="fa fa-search" />
</button>

<style lang="scss">
    @import "./styles/variables.scss";

    .button {
        // background-color: $dark-mauve;
        color: black;
    }
</style>
